module.exports = __webpack_public_path__ + "static/media/YM09_2.175f829d.jpg";